class CartChecker {
  constructor() {
    /** @type {Array<any>} */
    this.cartItems = [];
    this.isLoading = false;
    this.lastFetchTime = 0;
    this.cacheTimeout = 30000;
    this.setupCartEventListeners();
  }

  setupCartEventListeners() {
    const refreshCart = () => this.refreshCartData();
    document.addEventListener('cart:add', refreshCart);
    document.addEventListener('cart:update', refreshCart);
    document.addEventListener('cart:change', refreshCart);
  }

  async fetchCartData() {
    const now = Date.now();
    if (
      !this.isLoading &&
      now - this.lastFetchTime < this.cacheTimeout &&
      this.cartItems.length > 0
    ) {
      return this.cartItems;
    }

    if (this.isLoading) {
      return new Promise(resolve => {
        const checkLoading = () => {
          if (!this.isLoading) resolve(this.cartItems);
          else setTimeout(checkLoading, 100);
        };
        checkLoading();
      });
    }

    this.isLoading = true;
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      this.cartItems = cartData.items || [];
      this.lastFetchTime = now;
      return this.cartItems;
    } catch (error) {
      return this.cartItems;
    } finally {
      this.isLoading = false;
    }
  }

  async isVariantInCart(variantId) {
    const cartItems = await this.fetchCartData();
    return cartItems.some(
      item => String(item.variant_id) === String(variantId)
    );
  }

  async getCartItemByVariant(variantId) {
    const cartItems = await this.fetchCartData();
    return (
      cartItems.find(item => String(item.variant_id) === String(variantId)) ||
      null
    );
  }

  async getCartVariantIds() {
    const cartItems = await this.fetchCartData();
    return cartItems.map(item => String(item.variant_id));
  }

  async refreshCartData() {
    this.lastFetchTime = 0;
    return await this.fetchCartData();
  }

  async checkMultipleVariants(variantIds) {
    const cartVariantIds = await this.getCartVariantIds();
    const results = {};
    variantIds.forEach(variantId => {
      results[String(variantId)] = cartVariantIds.includes(String(variantId));
    });
    return results;
  }

  async getVariantQuantityInCart(variantId) {
    const cartItem = await this.getCartItemByVariant(variantId);
    return cartItem && typeof cartItem === 'object' && 'quantity' in cartItem
      ? Number(cartItem.quantity)
      : 0;
  }

  clearCache() {
    this.cartItems = [];
    this.lastFetchTime = 0;
  }
}

window.cartChecker = new CartChecker();
